import { Box, Image } from '@wix/design-system'
import { useContent } from '@wix/funnel-builder-lizard'
import React, { FC, useEffect } from 'react'

import { sendEmailToUser } from '../../../api/FunnelIntroMailer/sendEmail'
import { usePageLogger } from '../../../bi/mfi'
import WixStudioLogo from '../../reusable/icons/WixStudioLogo.svg'
import { WixMobileContentWrapper } from '../../reusable/WixMobileContentWrapper/WixMobileContentWrapper'
import { WixMobileDescription } from '../../reusable/WixMobileDescription/WixMobileDescription'
import { WixMobileHeading } from '../../reusable/WixMobileHeading/WixMobileHeading'
import { WixMobilePage } from '../../reusable/WixMobilePage/WixMobilePage'
import { TWixMobilePantone } from './typings/WixMobilePantone.content'
import { wixMobilePantoneDataHooks as dataHooks } from './WixMobilePantone.dataHooks'
import s from './WixMobilePantone.scss'

const PANTONE_EMAIL_TEMPLATE_NAME = 'trigger_studio_promotional_color-of-the-year_10112024_en'

export const WixMobilePantone: FC = () => {
  const { content } = useContent<TWixMobilePantone>()
  const pageLogger = usePageLogger()

  useEffect(() => {
    void pageLogger.screenView()
  }, [pageLogger])

  useEffect(() => {
    sendEmailToUser(PANTONE_EMAIL_TEMPLATE_NAME)
  }, [])

  return (
    <WixMobilePage>
      <WixMobileContentWrapper>
        <div className={s.logo}>
          <WixStudioLogo />
        </div>

        {content.illustrationImageUrl ? (
          <Box align="center" verticalAlign="middle" paddingTop="36px" paddingBottom="32px">
            <Image
              borderRadius={0}
              src={content.illustrationImageUrl}
              dataHook={dataHooks.illustrationImage()}
              transparent
            />
          </Box>
        ) : (
          <Box height="52px" />
        )}
        <WixMobileHeading dataHook={dataHooks.title()}>{content.title}</WixMobileHeading>
        <WixMobileDescription dataHook={dataHooks.description()}>{content.description}</WixMobileDescription>
      </WixMobileContentWrapper>
    </WixMobilePage>
  )
}
